module.exports = __webpack_public_path__ + "img/icon-box.b7e0c2e4.svg";